export default __webpack_public_path__ + "static/media/path_icon.0d792007.svg";